import React, { useState } from 'react';
import { Button } from '../buttons';
import LogoutPage from '../../../authentication/components/LogoutPage';
import useStyles from './UnauthorizedLoginPage.styles';

const UnauthorizedLoginPage = () => {
  const classes = useStyles();

  const [isLoggingOut, setIsLoggingOut] = useState();
  if (isLoggingOut) return <LogoutPage />;
  return (
    <div className={classes.root}>
      <p>You cannot access this application with this email address.</p>
      <Button primary onClick={() => setIsLoggingOut(true)}>
        Logout
      </Button>
    </div>
  );
};
export default UnauthorizedLoginPage;
